import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { Editor, Viewer } from '@toast-ui/react-editor';

import { useColorMode } from '../../../contexts';

import { CustomEditorProps } from '.';

import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';

function cleanMarkdownString(input?: string) {
  if (!input) return '';
  let cleaned = input.replace(/^["']+/, '');
  cleaned = cleaned.replace(/\\\\n/g, '\n');
  return cleaned.replace(/\\n/g, '\n');
}

const MarkdownEditor: React.FC<CustomEditorProps> = ({ value = '', onChange, readonly }) => {
  const editorRef = useRef<Editor>(null);

  const cleanValue = cleanMarkdownString(value);
  const { mode } = useColorMode();

  useEffect(() => {
    if (editorRef.current) {
      const instance = editorRef.current.getInstance();
      if (instance.getMarkdown() !== cleanValue) {
        instance.setMarkdown(cleanValue);
      }
    }
  }, [cleanValue]);

  const handleChange = () => {
    if (editorRef.current) {
      const md = editorRef.current.getInstance().getMarkdown();
      if (onChange) {
        onChange(md);
      }
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ p: 1, border: '1px solid #eee', borderRadius: 1, background: '#fff' }}>
        {readonly ? (
          <Viewer initialValue={cleanValue} usageStatistics={false} />
        ) : (
          <Editor
            ref={editorRef}
            initialValue={cleanValue}
            previewStyle="vertical"
            height="400px"
            initialEditType="markdown"
            useCommandShortcut
            usageStatistics={false}
            hideModeSwitch={true}
            previewHighlight={true}
            theme={mode === 'dark' ? 'dark' : 'light'}
            toolbarItems={[
              ['heading', 'bold', 'italic', 'strike'],
              ['hr', 'quote'],
              ['ul', 'ol', 'task', 'indent', 'outdent'],
              ['table', 'link'],
              ['code', 'codeblock']
            ]}
            onChange={handleChange}
          />
        )}
      </Box>
    </Box>
  );
};

export default MarkdownEditor;
